import React, { Component, Fragment } from 'react'
// import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { pick, path } from 'ramda'
import {
  Container, Card, Button, List, Divider, Label
} from 'semantic-ui-react'
import PlanActions from 'Redux/PlanRedux'
import AuthActions from 'Redux/AuthRedux'
import TeamActions from 'Redux/TeamRedux'

class Plans extends Component {

  state = {
    interval: 'monthly',
    team: {
      plan: {},
      subscription: {}
    }
  }

  componentDidMount () {
    const teamId = path(['params', 'teamId'], this.props.match)
    this.props.plansListRequest(teamId)
    this.props.teamsListRequest()
  }

  componentDidUpdate (prevProps) {
    if (this.props.teams !== prevProps.teams) {
      const team = this.props.teams.find(t => t.id === parseInt(this.props.match.params.teamId, 10)) || {plan:{}, subscription: {}}
      this.setState({ team })
      const teamId = path(['params', 'teamId'], this.props.match)
      this.props.plansListRequest(teamId)
      this.props.plansSetCurrentInterval(team.planType)
    }
  }

  selectPlan = (seekrevPlanId, paddlePlanId) => () => {
    if (paddlePlanId) {
      window.Paddle.Checkout.open({
        product: paddlePlanId,
        email: this.props.userData.email,
        passthrough: JSON.stringify(
          {
            ...pick(['id', 'name', 'provider', 'email'], this.props.userData),
            team_id: this.props.match.params.teamId,
            seekrev_plan_id: seekrevPlanId
          }
        ),
        success: `/projects`
      })
    } else {
      window.location.href = 'mailto:support@seekrev.com'
    }
  }

  changePlan = (planId, intervalProductId) => () => {
    // if subscription exist update
    if(this.state.team.subscription) {
      this.onPlanUpdate(planId, intervalProductId)
    }
    else {
      // else create new one
      this.selectPlan(planId, intervalProductId)()
    }
    
  }

  onPlanUpdate = (planId, intervalProductId) => {
    this.props.plansUpdateRequest(planId, {
      paddleSubscriptionId: this.state.team.subscription.subscriptionId,
      paddlePlanId: intervalProductId,
      teamId: this.state.team.id,
      subscriptionId: this.state.team.subscription.id,
      passthrough: JSON.stringify(
          {
            ...pick(['id', 'name', 'provider', 'email'], this.props.userData),
            team_id: this.props.match.params.teamId,
            seekrev_plan_id: planId
          })
    })
  }

  onSubscriptionCancel = (url) => () => {
    window.Paddle.Checkout.open({ override: url })
    // this.props.logoutRequest()
  }

  renderSubscriptionOptions(planId, intervalProductId) {
    
    if(this.state.team.plan.id === planId) {
      return (
        this.state.team.subscription ?
        <Fragment>
          <Button
            primary
            basic
            positive
            disabled
          >
            Subscribed 
          </Button>
        </Fragment>
        :
        <Button
          basic
          primary
          positive
          onClick={this.selectPlan(planId, intervalProductId)}>
            Buy Now
        </Button>
      )
    }
    else {
      if(this.state.team.subscription) {
        return (
          <Button
            basic
            primary
            onClick={this.selectPlan()}>
              Contact Sales
          </Button>
        )
      }

      return (
        <Button
          basic
          primary
          onClick={this.selectPlan(planId, intervalProductId)}>
            { intervalProductId
              ? 'Buy Now' : 'Contact Sales'
            }
        </Button>
        )
    }

  }

  renderPlanStatusRibbon = (plan) => {
    if(this.state.team.plan.id === plan.id) {
      return (<Label as='a' color={this.state.team.planColor} ribbon>
          {this.state.team.planStatus}
        </Label>
      )
    }
  }

  render() {
    const interval = this.props.currentInterval
    return (
      <Container>
        <Divider hidden />
        <div style={{textAlign: 'center'}}>
          <Button.Group>
            <Button
              primary={this.props.currentInterval === 'monthly'}
              onClick={this.props.plansSetCurrentInterval('monthly')}>
                Monthly
            </Button>
            <Button.Or />
            <Button
              primary={this.props.currentInterval === 'yearly'}
              onClick={this.props.plansSetCurrentInterval('yearly')}>
                Yearly
            </Button>
          </Button.Group>
        </div>
        <Divider hidden />
        <Card.Group itemsPerRow={3}>
          {this.props.plans.map(plan => (
            <Card key={plan[`${interval}ProductId`]}
              raised={this.state.team.plan.id === plan.id}
            >
              <Card.Content>
                {this.renderPlanStatusRibbon(plan)}
                <Card.Meta>{plan.title}</Card.Meta>
                <Card.Header>
                  {plan[`${interval}Price`]}
                </Card.Header>
                <Card.Description>
                  <List bulleted>
                    <List.Item>{plan.projects}</List.Item>
                    <List.Item>{plan.collaborators}</List.Item>
                    <List.Item>{plan.storage}</List.Item>
                    <List.Item>{plan.users}</List.Item>
                  </List>
                </Card.Description>
              </Card.Content>
              <Card.Content extra>
                <div className='ui two buttons'>
                  {this.renderSubscriptionOptions(plan.id, plan[`${interval}ProductId`])}
                </div>
              </Card.Content>
            </Card>
          ))}
        </Card.Group>
      </Container>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    userData: state.auth.userData,
    plans: state.plans.listData,
    currentInterval: state.plans.currentInterval,
    teams: state.teams.listData
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logoutRequest: () => dispatch(AuthActions.logoutRequest()),
    plansListRequest: (teamId) => {
      return dispatch(PlanActions.plansListRequest(teamId))
    },
    plansUpdateRequest: (id, updateParams) => {
      return dispatch(PlanActions.plansUpdateRequest(id, updateParams))
    },
    plansSetCurrentInterval: (interval) => () => {
      return dispatch(
        PlanActions.plansSetCurrentInterval(interval))
    },
    teamsListRequest: () => dispatch(TeamActions.teamsListRequest())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Plans)



// WEBPACK FOOTER //
// ./src/Pages/Subscription/Plans.js